const dateFormatter = new Intl.DateTimeFormat(undefined, {month: 'short', day: 'numeric', year: 'numeric'});
const timeFormatter = new Intl.DateTimeFormat(undefined, {hour: 'numeric', minute: 'numeric', second: 'numeric'});

export function formatDateShort(d: Date): any {
    if (!d || !d.toLocaleDateString) return d;
    return dateFormatter.format(d);
}

export function formatTime(d: Date): any {
    if (!d || !d.toLocaleTimeString) return d;
    return timeFormatter.format(d);
}

export interface ICancelablePromise<T> {
    promise: Promise<T>;
    cancel: () => void;
}

// If canceled, it silently ignores "then" and "catch" callbacks.
export function cancelablePromise<T>(p: Promise<T>): ICancelablePromise<T> {
    let isCanceled = false;
    const wrappedP = new Promise<T>((resolve, reject) => {
        p.then((result) => {
                if (!isCanceled) resolve(result);
            })
            .catch((e) => {
                if (!isCanceled) reject(e);
            });
    });

    return {
        promise: wrappedP,
        cancel: () => {
            isCanceled = true;
        }
    }
}